exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report[data-v-7fc0e240]{margin-top:30px}.center[data-v-7fc0e240]{text-align:center}.btn-export[data-v-7fc0e240]{text-align:right;margin-bottom:.25rem}.break-word[data-v-7fc0e240]{word-break:break-all}.colour-pdf[data-v-7fc0e240]{color:red}.colour-excel[data-v-7fc0e240]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7fc0e240","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportes/materiales/ConsultaMateriales.vue
// module id = 256
// module chunks = 58